// extracted by mini-css-extract-plugin
module.exports = {"wishlist-page":"wishlist_wishlist-page__2kmRm","product-grid":"wishlist_product-grid__14CG5"};